import { createFileRoute } from '@tanstack/react-router';
import { SignInCallbackPage } from '../../features/identity';

export const Route = createFileRoute('/_public/sign-in/callback')({ component: SignInCallbackPage });
